const styleOverrides = {
  fab: ({
    theme
  }) => ({
    width: 40,
    height: 40,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.common.white
    }
  })
};
export default {
  styleOverrides
};